<mat-progress-bar class="progress-bar" mode="determinate" [value]="valor"></mat-progress-bar>
